<h2 mat-dialog-title class="text-xl font-bold mb-4 px-6 py-4 border-b">
  {{ isEditMode ? 'Editar Registro' : 'Nuevo Registro' }}
</h2>

<mat-dialog-content class="overflow-y-auto max-h-full rounded-lg">
  <div class="px-6 py-4">
    <form [formGroup]="createForm" class="flex flex-col gap-5">

      <!-- Campo: Correo Electrónico -->
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Correo Electrónico</mat-label>
        <input
          matInput
          type="email"
          formControlName="email"
          placeholder="ejemplo@dominio.com"
          required
        />
        <mat-hint>Introduce un correo válido</mat-hint>
        <mat-error *ngIf="createForm.get('email')?.hasError('required')">
          El correo electrónico es obligatorio.
        </mat-error>
        <mat-error *ngIf="createForm.get('email')?.hasError('pattern')">
          Ingrese un correo electrónico válido.
        </mat-error>
      </mat-form-field>

      <!-- Campo: Tipo de correo -->
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Tipo de correo</mat-label>
        <mat-select formControlName="type">
          <mat-option *ngFor="let option of typeOptions" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
        <mat-hint>Selecciona el tipo de correo</mat-hint>
      </mat-form-field>

      <!-- Campo: Correo Principal -->
      <div class="flex items-center justify-between bg-white p-4 rounded-lg border">
        <span class="font-medium text-gray-700">¿Correo Principal?</span>
        <mat-slide-toggle formControlName="isPrincipal" color="primary"></mat-slide-toggle>
      </div>

    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-between items-center p-6 border-t mt-6">
  <button mat-button mat-dialog-close class="px-6 py-2">Cancelar</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="!createForm.valid" class="px-6 py-2">
    {{ isEditMode ? 'Actualizar' : 'Guardar' }}
  </button>
</mat-dialog-actions>